import { render, staticRenderFns } from "./dialog-text.vue?vue&type=template&id=6f52915b&scoped=true"
import script from "./dialog-text.vue?vue&type=script&lang=js"
export * from "./dialog-text.vue?vue&type=script&lang=js"
import style0 from "./dialog-text.vue?vue&type=style&index=0&id=6f52915b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f52915b",
  null
  
)

export default component.exports